// frontend/src/components/ContentTab.js
import RichTextEditor from "@/components/RichTextEditor";
import { Field, TextInput, SectionCard } from "@/components/shared";

function ContentTab({ config, onChange }) {
  const update = (path, value) => {
    const next = JSON.parse(JSON.stringify(config));
    const keys = path.split(".");
    let obj = next;
    for (let i = 0; i < keys.length - 1; i++) obj = obj[keys[i]];
    obj[keys[keys.length - 1]] = value;
    onChange(next);
  };

  return (
    <div className="space-y-4">
      <SectionCard title="Hero Section" accentColor={config.colors.primary}>
        <Field label="Headline">
          <RichTextEditor value={config.content.hero.headline} onChange={(v) => update("content.hero.headline", v)} minHeight="2.5rem" />
        </Field>
        <Field label="Tagline">
          <RichTextEditor value={config.content.hero.tagline} onChange={(v) => update("content.hero.tagline", v)} minHeight="2.5rem" />
        </Field>
        <Field label="Sub-line">
          <RichTextEditor value={config.content.hero.subline} onChange={(v) => update("content.hero.subline", v)} minHeight="4rem" />
        </Field>
      </SectionCard>

      <SectionCard title="Intro Section" accentColor={config.colors.secondary}>
        <Field label="Intro Text">
          <RichTextEditor value={config.content.intro.text} onChange={(v) => update("content.intro.text", v)} minHeight="5rem" />
        </Field>
        <Field label="Products Section Intro">
          <RichTextEditor value={config.content.intro.productsSectionIntro} onChange={(v) => update("content.intro.productsSectionIntro", v)} minHeight="2.5rem" />
        </Field>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Field label="Shop CTA Label (optional)">
            <TextInput value={config.content.intro.shopCtaLabel || ""} onChange={(v) => update("content.intro.shopCtaLabel", v)} />
          </Field>
          <Field label="Shop CTA URL (optional)">
            <TextInput value={config.content.intro.shopCtaUrl || ""} onChange={(v) => update("content.intro.shopCtaUrl", v)} />
          </Field>
        </div>
      </SectionCard>

      <SectionCard title="Footer Section" accentColor={config.colors.leadline}>
        <Field label="Closing Tagline">
          <RichTextEditor value={config.content.footer.closingTagline} onChange={(v) => update("content.footer.closingTagline", v)} minHeight="2.5rem" />
        </Field>
        <Field label="Company Name (copyright line)">
          <TextInput value={config.content.footer.companyName} onChange={(v) => update("content.footer.companyName", v)} />
        </Field>
        <Field label="Copyright Text">
          <RichTextEditor value={config.content.footer.copyrightText} onChange={(v) => update("content.footer.copyrightText", v)} minHeight="2.5rem" />
        </Field>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Field label="Sign Up Button Label">
            <TextInput value={config.content.footer.signupButtonLabel || ""} onChange={(v) => update("content.footer.signupButtonLabel", v)} />
          </Field>
          <Field label="Sign Up Button URL">
            <TextInput value={config.content.footer.signupButtonUrl || ""} onChange={(v) => update("content.footer.signupButtonUrl", v)} />
          </Field>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Field label="Shop Button Label">
            <TextInput value={config.content.footer.shopButtonLabel || ""} onChange={(v) => update("content.footer.shopButtonLabel", v)} />
          </Field>
          <Field label="Shop Button URL">
            <TextInput value={config.content.footer.shopButtonUrl || ""} onChange={(v) => update("content.footer.shopButtonUrl", v)} />
          </Field>
        </div>
      </SectionCard>
    </div>
  );
}

export default ContentTab;
